import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const ListOfYears = ({ text, forYears }) => {
  return (
    <Fragment>
      <p className="menu-label has-text-black">
        <b>{text}</b>
      </p>
      <ul className="menu-list">
        {forYears.map(({ to, forYear, active }) => (
          <li key={to}>
            <Link to={to} className={active ? `is-active` : ``}>
              {forYear}
            </Link>
          </li>
        ))}
      </ul>
    </Fragment>
  );
};

export default ListOfYears;



// WEBPACK FOOTER //
// ./src/presentational/ListOfYears/index.js